import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import RouterLinkButton from 'components/router-link-button'
import { useIsMobile } from 'lib/hooks'

const PaymentsUnavailableWarning = ({ lessonTypeId }) => {
  const isMobile = useIsMobile()
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={{
        borderRadius: '8px',
        backgroundColor: '#feecea',
        padding: '1rem',
      }}
      mb={3}
    >
      <Box
        display="flex"
        alignItems="center"
        width={isMobile ? 'unset' : '60%'}
        mr={1}
      >
        <Typography variant="body2" gutterBottom color="textPrimary">
          <strong>Payments unavailable.</strong> Your payment account needs
          attention before you can collect payments. Update your payment
          settings to continue.
        </Typography>
      </Box>
      <RouterLinkButton
        color="primary"
        variant="outlined"
        to={`/pga-coach/bookings/booking-types/edit/${lessonTypeId}#payment-options`}
        size={isMobile ? 'small' : 'medium'}
        fullWidth={isMobile}
        style={{ textAlign: 'center' }}
      >
        Payment Settings
      </RouterLinkButton>
    </Box>
  )
}

export default PaymentsUnavailableWarning
